(function () {
  'use strict';

  function initCarousels() {
    document.querySelectorAll('.card-carousel[data-product-id]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady) return;
      initOne(carousel);
      carousel.dataset.carouselReady = 'true';
    });
  }

  function initOne(carousel) {
    var track = carousel.querySelector('.card-carousel__track');
    if (!track) return;

    var slides = Array.from(carousel.querySelectorAll('.card-carousel__slide'));
    var dots = Array.from(carousel.querySelectorAll('.card-carousel__dot'));
    var prevBtn = carousel.querySelector('.card-carousel__btn--prev');
    var nextBtn = carousel.querySelector('.card-carousel__btn--next');
    var productId = carousel.dataset.productId;
    var current = 0;
    var total = slides.length;

    if (total <= 1) return;

    function revealImg(slide) {
      if (!slide) return;
      var img = slide.querySelector('img');
      if (!img) return;
      img.setAttribute('loading', 'eager');
      if (!img.complete || img.naturalWidth === 0) {
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src);
      }
    }

    function goTo(index, skipReveal) {
      if (total <= 0) return;
      index = ((index % total) + total) % total;
      current = index;
      // Kill any legacy translate that blanks the stack
      track.style.transform = 'none';
      track.style.webkitTransform = 'none';

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
        s.style.flex = '';
        s.style.width = '';
        s.style.minWidth = '';
        s.style.maxWidth = '';
        if (!skipReveal && (i === current || Math.abs(i - current) === 1)) revealImg(s);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    // Không tải mọi slide từ đầu, để trình duyệt tự lazy-load,
    // Tải trước slide 2 khi scroll product card sắp vào màn hình
    goTo(0, true);
    var warmed = false;
    function warmNext() {
      if (warmed) return;
      warmed = true;
      revealImg(slides[1]);
    }
    if ('IntersectionObserver' in window) {
      var warmObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        warmObserver.disconnect();
        warmNext();
      }, { rootMargin: '200px' });
      warmObserver.observe(carousel);
    }
    carousel.addEventListener('pointerenter', warmNext, { once: true });
    carousel.addEventListener('touchstart', warmNext, { once: true, passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(parseInt(dot.dataset.index, 10));
      });
    });
    var startX = 0;
    var startY = 0;
    var isDragging = false;

    carousel.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = false;
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > dy && dx > 5) isDragging = true;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(current + (diff > 0 ? 1 : -1));
      }
    });
    // Sync với Vario variant change

    // Đọc variant–media map từ <script type="application/json">
    var mapScript = document.querySelector(
      'script[data-variant-media-map="' + productId + '"]'
    );
    if (!mapScript) return;

    var variantMediaMap = {};  // variantId -> mediaId
    var mediaIndexMap = {};    // mediaId -> slideIndex

    try {
      var data = JSON.parse(mapScript.textContent);
      if (data.variantMedia) {
        data.variantMedia.forEach(function (item) {
          variantMediaMap[item.variantId] = item.mediaId;
        });
      }
    } catch (e) {
      console.warn('[card-carousel] Cannot parse variant media map', e);
      return;
    }

    // Build mediaId -> slide index
    slides.forEach(function (slide, i) {
      if (slide.dataset.mediaId) {
        mediaIndexMap[slide.dataset.mediaId] = i;
      }
    });

    function jumpToVariant(variantId) {
      var mediaId = variantMediaMap[variantId];
      if (mediaId == null) return;
      var idx = mediaIndexMap[String(mediaId)];
      if (idx != null) goTo(idx);
    }
    document.addEventListener('variant:changed', function (e) {
      if (!e.detail) return;
      var vid = (e.detail.variant && e.detail.variant.id) || e.detail.variantId;
      if (vid) jumpToVariant(vid);
    });
    var cardWrapper = carousel.closest('.card-wrapper');
    if (cardWrapper) {
      cardWrapper.addEventListener('change', function (e) {
        var target = e.target;
        if (target.name === 'id' || target.classList.contains('product-variant-id')) {
          jumpToVariant(parseInt(target.value, 10));
        }
      });
    }
    // (Vario update value attr trực tiếp mà không fire 'change')
    if (cardWrapper) {
      var variantInput = cardWrapper.querySelector('input.product-variant-id');
      if (variantInput) {
        var observer = new MutationObserver(function () {
          jumpToVariant(parseInt(variantInput.value, 10));
        });
        observer.observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }
    }
    var cardEl = carousel.closest('.card-indochinalight, .card-wrapper');
    if (cardEl) {
      cardEl.addEventListener('click', function (e) {
        var swatch = e.target.closest('.card-indochinalight__color-swatch');
        if (!swatch) return;
        e.preventDefault();
        e.stopPropagation();

        // Update selected state
        var allSwatches = cardEl.querySelectorAll('.card-indochinalight__color-swatch');
        allSwatches.forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');

        // Jump carousel to variant media
        var mediaId = swatch.dataset.mediaId;
        if (mediaId) {
          var idx = mediaIndexMap[String(mediaId)];
          if (idx != null) goTo(idx);
        }
      });
    }
  }

  function findQuickViewRoot(fromEl) {
    return (
      fromEl.closest('.card__inner__media') ||
      fromEl.closest('.card-wrapper') ||
      fromEl.closest('.grid__item')
    );
  }

  function findQuickViewTrigger(fromEl) {
    var root = findQuickViewRoot(fromEl);
    if (!root) return null;
    return (
      root.querySelector('.hktqv_Trigger__QuickView') ||
      root.querySelector('.hktqv_Trigger .hktqv_Trigger__Item') ||
      root.querySelector('[class*="hktqv_Trigger__QuickView"]')
    );
  }

  function openQuickViewFromButton(btn) {
    var root = findQuickViewRoot(btn);
    var trigger = findQuickViewTrigger(btn);
    if (trigger) {
      trigger.click();
      return true;
    }
    if (root) {
      var ecomLink = root.querySelector('.ecom-product-quickview');
      if (ecomLink) {
        ecomLink.click();
        return true;
      }
    }
    var url = btn.getAttribute('data-product-url');
    if (url) {
      window.location.href = url;
      return true;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.card-indochinalight__view');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      // HKT injects trigger async — retry briefly if not ready
      if (openQuickViewFromButton(btn)) return;

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (openQuickViewFromButton(btn) || tries >= 10) {
          clearInterval(timer);
        }
      }, 100);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  document.addEventListener('shopify:section:load', function () {
    initCarousels();
  });

  // Re-init when theme/Vario injects cards
  if (window.MutationObserver) {
    var domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('card-carousel')) {
            if (!node.dataset.carouselReady) {
              initOne(node);
              node.dataset.carouselReady = 'true';
            }
          }
          // Carousel bên trong node vừa thêm
          node.querySelectorAll && node.querySelectorAll('.card-carousel[data-product-id]').forEach(function (c) {
            if (!c.dataset.carouselReady) {
              initOne(c);
              c.dataset.carouselReady = 'true';
            }
          });
        });
      });
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

})();